module.exports = __webpack_public_path__ + "static/media/concierge-bell.e5aaa89d.svg";